'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var AuthService = /** @class */ (function () {
    function AuthService() {
    }
    AuthService.setHttpClient = function (client) {
        this.httpClient = client;
    };
    AuthService.signUp = function (user) {
        return this.httpClient.post('/users', { user: user });
    };
    AuthService.signIn = function (user) {
        return this.httpClient.post('/users/sign_in', { user: user });
    };
    AuthService.signOut = function () {
        return this.httpClient.delete('/users/sign_out');
    };
    AuthService.validateToken = function () {
        return this.httpClient.get('/users/validate_token');
    };
    AuthService.updateUser = function (user, passwordCheck) {
        return this.httpClient.patch('/user', { user: user, passwordCheck: passwordCheck });
    };
    AuthService.requestPasswordReset = function (email) {
        return this.httpClient.post('/users/password', { email: email });
    };
    AuthService.verifyPasswordReset = function (resetPasswordToken) {
        return this.httpClient.get('users/password/edit', {
            params: { resetPasswordToken: resetPasswordToken },
        });
    };
    AuthService.resetPassword = function (password, resetPasswordToken) {
        return this.httpClient.put('/users/password', {
            password: password,
            resetPasswordToken: resetPasswordToken,
        });
    };
    return AuthService;
}());

var applyInterceptors = function (client, session, clearSession) {
    var requestInterceptor = client.interceptors.request.use(function (request) {
        if (session) {
            Object.assign(request.headers, session);
        }
        return request;
    });
    var responseInterceptor = client.interceptors.response.use(function (response) { return response; }, function (error) {
        if (!error.response || !error.response.data) {
            return Promise.reject({ errors: ['Connection error'] });
        }
        if (error.response.status === 401) {
            clearSession();
        }
        return Promise.reject(error.response.data);
    });
    return [requestInterceptor, responseInterceptor];
};
var clearInterceptors = function (client, interceptors) {
    var requestInterceptor = interceptors[0], responseInterceptor = interceptors[1];
    client.interceptors.request.eject(requestInterceptor);
    client.interceptors.response.eject(responseInterceptor);
};

var AuthContext = react.createContext({});
var defaultState = {
    user: null,
    session: null,
    isLoading: false,
};
var initialState = function () {
    var storedSession = JSON.parse(localStorage.getItem('session'));
    if (storedSession) {
        return __assign(__assign({}, defaultState), { session: storedSession, isLoading: true });
    }
    return defaultState;
};
function AuthProvider(_a) {
    var _this = this;
    var children = _a.children, httpClient = _a.httpClient, prepopulatedState = _a.prepopulatedState;
    var _b = react.useState(prepopulatedState || initialState), state = _b[0], setState = _b[1];
    var user = state.user, session = state.session, isLoading = state.isLoading;
    var validateSession = react.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, accessToken, client, uid, data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(isLoading && session)) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, AuthService.validateToken()];
                case 2:
                    response = _c.sent();
                    _a = response.headers, accessToken = _a.accessToken, client = _a.client, uid = _a.uid, data = response.data;
                    setState({
                        session: { accessToken: accessToken, client: client, uid: uid },
                        user: data.user,
                        isLoading: false,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _c.sent();
                    setState(defaultState);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [isLoading, session]);
    var signIn = react.useCallback(function (values) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, accessToken, client, uid, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, AuthService.signIn(values)];
                case 1:
                    response = _b.sent();
                    _a = response.headers, accessToken = _a.accessToken, client = _a.client, uid = _a.uid, data = response.data;
                    setState({
                        session: { accessToken: accessToken, client: client, uid: uid },
                        user: data.user,
                        isLoading: false,
                    });
                    return [2 /*return*/, response];
            }
        });
    }); }, []);
    var signUp = react.useCallback(function (values) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, accessToken, client, uid, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, AuthService.signUp(values)];
                case 1:
                    response = _b.sent();
                    _a = response.headers, accessToken = _a.accessToken, client = _a.client, uid = _a.uid, data = response.data;
                    setState({
                        session: { accessToken: accessToken, client: client, uid: uid },
                        user: data.user,
                        isLoading: false,
                    });
                    return [2 /*return*/, response];
            }
        });
    }); }, []);
    var updateUser = react.useCallback(function (values, passwordCheck) {
        if (passwordCheck === void 0) { passwordCheck = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AuthService.updateUser(values, passwordCheck)];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        setState(function (prevState) { return (__assign(__assign({}, prevState), { user: data.user })); });
                        return [2 /*return*/, response];
                }
            });
        });
    }, []);
    var signOut = react.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setState(defaultState);
            return [2 /*return*/, AuthService.signOut()];
        });
    }); }, []);
    var clearSession = react.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setState(defaultState);
            return [2 /*return*/];
        });
    }); }, []);
    var requestPasswordReset = react.useCallback(function (email) { return AuthService.requestPasswordReset(email); }, []);
    var verifyPasswordReset = react.useCallback(function (resetPasswordToken) { return AuthService.verifyPasswordReset(resetPasswordToken); }, []);
    var resetPassword = react.useCallback(function (password, resetPasswordToken) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, accessToken, client, uid, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, AuthService.resetPassword(password, resetPasswordToken)];
                case 1:
                    response = _b.sent();
                    _a = response.headers, accessToken = _a.accessToken, client = _a.client, uid = _a.uid, data = response.data;
                    setState({
                        session: { accessToken: accessToken, client: client, uid: uid },
                        user: data.user,
                        isLoading: false,
                    });
                    return [2 /*return*/, response];
            }
        });
    }); }, []);
    react.useEffect(function () {
        AuthService.setHttpClient(httpClient);
    }, [httpClient]);
    react.useEffect(function () {
        var interceptors = applyInterceptors(httpClient, session, clearSession);
        return function () { return clearInterceptors(httpClient, interceptors); };
    }, [httpClient, session, clearSession]);
    react.useEffect(function () {
        validateSession();
    }, [validateSession]);
    react.useEffect(function () {
        if (session) {
            localStorage.setItem('session', JSON.stringify(session));
        }
        else {
            localStorage.removeItem('session');
        }
    }, [session]);
    return (jsxRuntime.jsx(AuthContext.Provider, __assign({ value: {
            isLoading: isLoading,
            isAuthenticated: user !== null,
            session: session,
            user: user,
            signIn: signIn,
            signUp: signUp,
            updateUser: updateUser,
            signOut: signOut,
            clearSession: clearSession,
            requestPasswordReset: requestPasswordReset,
            verifyPasswordReset: verifyPasswordReset,
            resetPassword: resetPassword,
        } }, { children: children }), void 0));
}
AuthProvider.defaultProps = {
    prepopulatedState: null,
};

var useAuth = function () { return react.useContext(AuthContext); };

exports.AuthProvider = AuthProvider;
exports.useAuth = useAuth;
